import React from 'react'
import { Icon } from '@iconify/react';

export default function ContactInfoWidget({ withIcon, title }) {
  return (
    <>
      {title && <h2 className="cs-widget_title">{title}</h2>}
      <ul className="cs-menu_widget cs-style1 cs-mp0">
        <a href="tel:+919501412704" >
          <li style={{ marginBottom: '8px' }}>

            {withIcon ? <span className='cs-accent_color'><Icon icon="material-symbols:add-call-rounded" /></span> : ''}
             080-69409347


          </li>
        </a>

        <a href="mailto:magic@justcharge.in"  >
          <li style={{ marginBottom: '8px' }}>

            {withIcon && <span className='cs-accent_color'><Icon icon="mdi:envelope" /></span>}
            magic@justcharge.in

          </li>
        </a>
        <li>

          {withIcon ? <span className='cs-accent_color'><Icon icon="mdi:map-marker" /></span> : ''}
          Just Charge C89C, Sec-8 <br />Noida - 201301
        </li>
      </ul>
    </>
  )
}
